export default __webpack_public_path__ + "static/media/keyboardUI.cdc01d9d.PNG";